import { CheckCircle, User, ClipboardList, FileText, Mail } from 'lucide-react'

const STEPS = [
  { id: 'client-info', label: 'Informations client', icon: User },
  { id: 'assessment', label: 'Évaluation par thèmes', icon: ClipboardList },
  { id: 'results', label: 'Résultats', icon: FileText },
  { id: 'success', label: 'Envoi confirmé', icon: Mail }
]

function ProgressStepper({ currentStep }) {
  const getCurrentStepIndex = () => {
    return STEPS.findIndex(step => step.id === currentStep)
  }

  const currentIndex = getCurrentStepIndex()

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex justify-between items-center">
        {STEPS.map((step, index) => {
          const Icon = step.icon
          const isCompleted = index < currentIndex
          const isCurrent = index === currentIndex
          const isUpcoming = index > currentIndex

          return (
            <div key={step.id} className="flex flex-col items-center flex-1">
              <div className="flex items-center w-full">
                {/* Step Circle */}
                <div className={`
                  flex items-center justify-center w-10 h-10 rounded-full border-2 
                  ${isCompleted 
                    ? 'bg-green-500 border-green-500 text-white' 
                    : isCurrent 
                      ? 'bg-cedec-blue border-cedec-blue text-white'
                      : 'bg-gray-100 border-gray-300 text-gray-400'
                  }
                `}>
                  {isCompleted ? (
                    <CheckCircle className="w-5 h-5" />
                  ) : (
                    <Icon className="w-5 h-5" />
                  )}
                </div>

                {/* Connecting Line */}
                {index < STEPS.length - 1 && (
                  <div className={`
                    flex-1 h-0.5 mx-2
                    ${index < currentIndex ? 'bg-green-500' : 'bg-gray-300'}
                  `} />
                )}
              </div>

              {/* Step Label */}
              <div className={`
                mt-2 text-sm text-center font-medium
                ${isCompleted 
                  ? 'text-green-600' 
                  : isCurrent 
                    ? 'text-cedec-blue'
                    : 'text-gray-400'
                }
              `}>
                {step.label}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ProgressStepper
